module.exports = __webpack_public_path__ + "img/p60-2008-shuangyuekan.1bb50585.jpg";